var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.onCopy}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.isCopying)?_c('span',{key:"copy",staticClass:"copy"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.isCopying)?_c('span',{key:"copied",staticClass:"copied"},[_vm._v("Copied!")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }